import { render, staticRenderFns } from "./mobile-notedevice.vue?vue&type=template&id=6396e053&scoped=true&"
import script from "./mobile-notedevice.vue?vue&type=script&lang=js&"
export * from "./mobile-notedevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396e053",
  null
  
)

export default component.exports